import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { FeeService } from 'src/app/private/services/fee-service.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-create-fee-structure',
  imports: [SharedModule],
  templateUrl: './create-fee-structure.component.html',
  styleUrl: './create-fee-structure.component.scss'
})
export class CreateFeeStructureComponent {

  @Input() type: string = 'Create';
  @Input() feeStructureData: any;
  @Input() allFeeGroups: any[] = []; // dropdown for groups
  @Input() group_id: string = ''; 


  @Output() closeDialog = new EventEmitter();
  @Output() reload = new EventEmitter();

  isSubmitted = false;
  btnLoading = false;

  feeStructureForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private api: FeeService,
    private localStorage: LocalStorageService
  ) {
    this.feeStructureForm = this.fb.group({
      organization_id: [this.localStorage.getOrganizationId() || '', Validators.required],
      campus_id: [this.localStorage.getCampusId() || ''],
      group_id: [this.group_id || ''],
      fee_name: ['', Validators.required],
      amount: ['', Validators.required],
      created_by: [this.localStorage.getUserId() || null]
    });
  }

  ngOnInit() {
    console.log("group_id", this.group_id);
    if (this.type === 'Update' && this.feeStructureData) {
      this.feeStructureForm.patchValue({
        group_id: this.feeStructureData.group_id,
        fee_name: this.feeStructureData.fee_name,
        amount: this.feeStructureData.amount,
        due_date: this.feeStructureData.due_date,
        organization_id: this.feeStructureData.organization_id,
        campus_id: this.feeStructureData.campus_id,
        created_by: this.feeStructureData.created_by
      });
    }
  }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  onSubmit() {
    this.isSubmitted = true;

    if (this.feeStructureForm.valid) {
      this.btnLoading = true;
      this.feeStructureForm.patchValue({ organization_id: this.localStorage.getOrganizationId() });
      this.feeStructureForm.patchValue({ group_id : this.group_id });
      const payload = this.feeStructureForm.value;

      const apiCall = this.type === 'Create'
        ? this.api.createFeeStructure(payload)
        : this.api.updateFeeStructure({ id: this.feeStructureData.id, ...payload });

      apiCall.subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: `Fee Structure ${this.type === 'Create' ? 'created' : 'updated'} successfully`
          });
          this.feeStructureForm.reset();
          this.isSubmitted = false;
          this.reload.emit();
          this.handleCloseDialog();
          this.btnLoading = false;
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `Failed to ${this.type.toLowerCase()} Fee Structure`
          });
          this.btnLoading = false;
        }
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Validation Error',
        detail: 'Please fill all required fields'
      });
    }
  }
}